module.exports = __webpack_public_path__ + "static/media/tw.c500350a.svg";